import { render, staticRenderFns } from "./msConfigLayout.vue?vue&type=template&id=aec36b64&scoped=true"
import script from "./msConfigLayout.vue?vue&type=script&lang=js"
export * from "./msConfigLayout.vue?vue&type=script&lang=js"
import style0 from "./msConfigLayout.vue?vue&type=style&index=0&id=aec36b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec36b64",
  null
  
)

export default component.exports